/**
 * Drupal behavious for Dynamic Page content type
 */

(function ($, Drupal) {
  'use strict';

  /**
   * Anchor a layout midway of the bottom of its parent
   */
  Drupal.behaviors.atp2017LayoutAnchorBottomCenter = {
    attach: function (context, settings) {
      $(context)
        .find('.l-anchor-bottom-center')
        .once('atp2017-l-anchor-bottom-center')
        .each(function () {
          let Parent = $(this).parents('.node--type-dynamic-page');

          if (Parent.length) {
            const Item = $(this);
            const itemHeight = $(this).outerHeight();

            Parent.css({
              'margin-bottom': (itemHeight / 2),
              'padding-bottom': (itemHeight / 2)
            });

            if (Parent.css('position') === 'static') {
              Parent.css('position', 'relative');
            }

            Item.css({
              'bottom': '0',
              'left': '50%',
              'position': 'absolute',
              'transform': 'translate(-50%, 50%)'
            });
          }
        });
    }
  };

  /**
   * Anchor a layout midway of the bottom of its parent
   */
  Drupal.behaviors.atp2017FindWorkshop = {
    attach: function (context, settings) {
      $(context)
        .find('#lkn--find-workshop')
        .once('atp2017-find-workshop')
        .click(function () {
          $(this).blur();

          const content = "<h3>You are leaving the<br/>Appetite to Play Website</h3>" +
            "<p><strong>Once you get to the BC Early Years Professional Development Portal search for ‘Appetite to Play’.</strong></p>" +
            "<p class=\"note\"><em>* Please note that only some of the Appetite to Play workshops are listed on the portal, so if you can't find one in your community, email us and we can help you</em></p>" +
            "<div><strong>Continue to browse workshops</strong></div>"/* +
            "<div class=\"actions\"><a href=\"#\" class=\"lnk--yes button--general\">Yes</a><a href=\"#\" class=\"lnk--cancel button--general\">Cancel</a></div>"*/;

          $('<div id="modal--workshop" />')
            .html(content)
              .dialog({
                classes: {
                  'ui-dialog': 'ui-corner-all position-fixed workshop',
                  'ui-dialog-titlebar': 'minimal',
                  'ui-dialog-content': 'text-align-center',
                  'ui-dialog-buttonpane': 'minimal text-align-center',
                  'ui-dialog-buttonset': 'no-float text-align-center'
                },
                modal: true,
                buttons: [
                  {
                    text: "Yes",
                    click: function() {
                      $( this ).dialog('close');

                      const win = window.open('https://earlyyearsbc.ca/', '_blank');
                      if (win) {
                          win.focus();
                      } else {
                          alert('Please allow popups for this website');
                      }
                    }
                  },
                  {
                    text: "Cancel",
                    class: "cancel",
                    click: function() {
                      $( this ).dialog('close');
                    }
                  }
                ],
                width: 430
              });
            // Remove focus on all buttons in the dialog window
            $('.ui-dialog :button').blur();

          return false;
        });
    }
  };

})(jQuery, Drupal);
